/*import Vue from 'vue'*/
import EventUtils from '@/utils/EventUtils.js';
import MapUtils from '@/utils/MapUtils.js';
import ConstUtils from '@/utils/ConstUtils.js'
import RcResponseEvent from '@/domain/model/events/RcResponseEvent.js';

import ChecklistResultMap from '@/domain/model/checklist/result/ChecklistResultMap.js';
import ChecklistResult from '@/domain/model/checklist/result/ChecklistResult.js';

const state = {
  list: [],
  map: {},
};

const getters = {
    ChecklistResultStorage: state => state,
};

const actions = {
};

const mutations = {
  SOCKET_ONMESSAGE (state, event)  {
    if (event.status == EventUtils.STATUS.COMPLETE && event.statusCode == EventUtils.CODE.OK && !EventUtils.isDetached(event)) {
      var payload = event[RcResponseEvent.Fields.PAYLOAD];
      if (payload) {
        var map = payload[ChecklistResultMap.MODEL_NAME];
        if (map) {
          state.map = MapUtils.updateMap(map, state.map);
        }
        var item = payload[ChecklistResult.MODEL_NAME];
        if (item) {
          state.map[item[ConstUtils.FIELDS.ID]] = item;
        }
        state.list = Object.values(state.map);
      }
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};